import { render, staticRenderFns } from "./UpdateData.vue?vue&type=template&id=611c1c7d&scoped=true&"
import script from "./UpdateData.vue?vue&type=script&lang=js&"
export * from "./UpdateData.vue?vue&type=script&lang=js&"
import style0 from "./UpdateData.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UpdateData.vue?vue&type=style&index=1&id=611c1c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c1c7d",
  null
  
)

export default component.exports